import React, { useState } from "react";
import InputTextField from "../../../Components/Interfaces/InputTextField";
import DropdownField from "../../../Components/Interfaces/DropdownField";
import FormActionButtons from "../../../Components/Interfaces/FormActionButtons";
import { use } from "react";
import { useNavigate } from "react-router-dom";
import { PostAPI } from "../../../ApiServices/ApiServices";

const Signup = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    specialisation: "",
    practiceType: "",
    practiceName: "",
    email: "",
    password: "",
  });
  const navigate = useNavigate();
  const specialisationOptions = [
    { value: "cardiology", label: "Cardiology" },
    { value: "dermatology", label: "Dermatology" },
    { value: "neurology", label: "Neurology" },
    { value: "orthopedic", label: "Orthopedic" },
    { value: "general", label: "General Physician" },
  ];

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

const handleSubmit = () => {
  const payload = {
    full_name: formData.fullName,
    email: formData.email,
    password: formData.password,
    practice_name: formData.practiceName,
    practice_type: formData.practiceType,
    specialization: formData.specialisation,
  };

  PostAPI(
    {
      url: "auth/doctor/register",
      data: payload,
    },
    (res) => {
      if (res?.success) {
        console.log("Signup success:", res);
        navigate("/"); // or login page
      } else {
        console.error("Signup error:", res?.message);
      }
    }
  );
};

  return (
    <div className="login-form container">
      <div className="row justify-content-center">
        <h4 className="form-head forgot-ps">Sign Up</h4>

       <div className="col-10 m-2">
  <div
    className="p-4 bg-white signup-scroll"
    style={{
      borderRadius: "20px",
      border: "1px solid #000405",
    }}
  >
            {/* Full Name */}
            <div className="mb-3">
              <InputTextField
                label="Full Name *"
                placeholder="Enter Full Name here"
                value={formData.fullName}
                onChange={(e) => handleChange("fullName", e.target.value)}
              />
            </div>

            {/* Specialisation */}
            <div className="mb-3">
              <DropdownField
                label="Specialisation *"
                placeholder="Select Specialisation"
                options={specialisationOptions}
                value={formData.specialisation}
                className="bg-bl2 border-0"
                onChange={(e) =>
                  handleChange("specialisation", e.target.value)
                }
              />
            </div>

            {/* Practice Type */}
            <div className="mb-3">
              <label className="fw-semibold mb-2 d-block">
                Practice Type *
              </label>

              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="radio"
                  name="practiceType"
                  value="solo"
                  checked={formData.practiceType === "solo"}
                  onChange={(e) =>
                    handleChange("practiceType", e.target.value)
                  }
                />
                <label className="form-check-label">
                  Solo Clinic
                </label>
              </div>

              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="radio"
                  name="practiceType"
                  value="multi"
                  checked={formData.practiceType === "multi"}
                  onChange={(e) =>
                    handleChange("practiceType", e.target.value)
                  }
                />
                <label className="form-check-label">
                  Multi-Doctor Clinic
                </label>
              </div>

              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="practiceType"
                  value="hospital"
                  checked={formData.practiceType === "hospital"}
                  onChange={(e) =>
                    handleChange("practiceType", e.target.value)
                  }
                />
                <label className="form-check-label">
                  Hospital
                </label>
              </div>
            </div>

            {/* Practice Name */}
            <div className="mb-3">
              <InputTextField
                label="Practice Name *"
                placeholder="Enter here"
                value={formData.practiceName}
                onChange={(e) =>
                  handleChange("practiceName", e.target.value)
                }
              />
            </div>

            {/* Email */}
            <div className="mb-3">
              <InputTextField
                label="Email ID *"
                placeholder="Enter email ID here"
                value={formData.email}
                autocomplete="email"
                onChange={(e) => handleChange("email", e.target.value)}
              />
            </div>

            {/* Password */}
            <div className="mb-4">
              <InputTextField
                label="Password *"
                type="password"
                placeholder="Enter Password here"
                value={formData.password}
                autocomplete="new-password"
                onChange={(e) =>
                  handleChange("password", e.target.value)
                }
              />
            </div>

            {/* Signup Button */}
            <div className="d-grid">
              <FormActionButtons
                submitLabel="Signup"
                onSubmit={handleSubmit}
                onCancel={()=>navigate("/")}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;